module.exports = __webpack_public_path__ + "media/bootstrap-icons/justify-left-fb0a1a30.svg";